var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-achievements-tab"},[_vm._m(0),_c('div',{staticClass:"l-achievement-grid"},_vm._l((_vm.rows),function(row,i){return _c('secret-achievement-row',{key:i,attrs:{"row":row}})}),1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-achievements-tab__header"},[_c('span',[_vm._v(" Secret Achievements are optional and give no bonuses. ")])])
}]

export { render, staticRenderFns }